import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import IMask from 'imask';
import { useMemo } from 'react';

// import { useWhatChanged } from '@simbathesailor/use-what-changed'

var regex = /[^a-zA-Z0-9]+/g;
//look at resources: datePickerInternal
// info on date formats:
// https://date-fns.org/v2.0.0-alpha.6/docs/parse
// https://www.ibm.com/docs/en/cmofz/10.1.0?topic=SSQHWE_10.1.0/com.ibm.ondemand.mp.doc/arsa0257.htm
var dayMask = {
  mask: IMask.MaskedRange,
  from: 1,
  to: 31,
  maxLength: 2
};
var monthMask = {
  mask: IMask.MaskedRange,
  from: 1,
  to: 12,
  maxLength: 2
};
var yyyyMask = {
  mask: IMask.MaskedRange,
  from: 1900,
  to: 2300
};
var yMask = {
  mask: IMask.MaskedRange,
  from: 0,
  to: 99
};
var useDateMask = function useDateMask(_ref) {
  var dateFormat = _ref.dateFormat,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate;
  var dateSeparator = useMemo(function () {
    var _dateFormat$match;
    return ((_dateFormat$match = dateFormat.match(regex)) === null || _dateFormat$match === void 0 ? void 0 : _dateFormat$match[0]) || '/';
  }, [dateFormat]);
  var datePositions = useMemo(function () {
    var upper = dateFormat.toUpperCase();
    var split = upper.split(dateSeparator);
    var year = split.findIndex(function (e) {
      return e.includes('Y');
    });
    var day = split.findIndex(function (e) {
      return e.includes('D');
    });
    var month = split.findIndex(function (e) {
      return e.includes('M');
    });
    return {
      year: year,
      day: day,
      month: month
    };
  }, [dateFormat, dateSeparator]);
  var iMaskDateFormat = dateFormat.split(dateSeparator).join('{' + dateSeparator + '}`');

  // useWhatChanged(
  //   [
  //     dateFormat,
  //     iMaskDateFormat,
  //     minDate,
  //     maxDate,
  //     dateSeparator,
  //     datePositions
  //   ],
  //   'dateFormat, iMaskDateFormat, minDate, maxDate, dateSeparator, datePositions'
  // )

  var maskOptions = useMemo(function () {
    return {
      mask: Date,
      //lazy: false,
      placeholder: dateFormat,
      pattern: iMaskDateFormat,
      //'m{/}`d{/}`Y',
      min: minDate !== null && minDate !== void 0 ? minDate : undefined,
      max: maxDate !== null && maxDate !== void 0 ? maxDate : undefined,
      blocks: {
        //need to add every possible option across cults
        d: dayMask,
        dd: dayMask,
        MM: monthMask,
        MMM: monthMask,
        yyyy: yyyyMask,
        y: yMask
      },
      // define date -> str conversion
      format: function format(date) {
        if (!date) {
          return '';
        }
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        var split = dateFormat.split(dateSeparator);
        var yearFormat = split[datePositions.year];
        var dayStr = day.toString();
        var monthStr = month.toString();
        var yearStr = year.toString();
        switch (yearFormat) {
          case 'y':
            yearStr = year.toString().substring(2);
            break;
          case 'yyyy':
          default:
            yearStr = year.toString();
            break;
        }
        if (day < 10) {
          dayStr = '0' + day;
        }
        if (month < 10) {
          monthStr = '0' + month;
        }
        var dateSet = Object.entries(datePositions).map(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
            k = _ref3[0],
            v = _ref3[1];
          var value = '';
          switch (k) {
            case 'month':
              value = monthStr;
              break;
            case 'day':
              value = dayStr;
              break;
            case 'year':
              value = yearStr;
              break;
          }
          return {
            key: k,
            sort: v,
            value: value
          };
        }).sort(function (a, b) {
          return a.sort > b.sort ? 1 : -1;
        }).reduce(function (acc, curr) {
          return [].concat(_toConsumableArray(acc), [curr.value]);
        }, []).join(dateSeparator);
        return dateSet;
      },
      // define str -> date conversion
      parse: function parse(str) {
        var yearMonthDay = str.split(dateSeparator);
        var year = datePositions.year,
          month = datePositions.month,
          day = datePositions.day;
        var yearStr = yearMonthDay[year];
        var yearValue = parseInt(yearStr);
        var numYearDigits = yearStr === null || yearStr === void 0 ? void 0 : yearStr.length;
        switch (numYearDigits) {
          case 2:
            yearValue = yearValue > 50 ? parseInt('19' + yearStr) : parseInt('20' + yearStr);
            break;
        }
        var d = new Date(yearValue, parseInt(yearMonthDay[month]) - 1, parseInt(yearMonthDay[day]));
        return d;
      },
      parsePartialDate: function parsePartialDate(str) {
        //function to parse partial value to be passed to React DatePicker Calendar selected value
        var currentDate = new Date();
        var yearMonthDay = str.split(dateSeparator);
        var year = datePositions.year,
          month = datePositions.month,
          day = datePositions.day;
        var yearStr = yearMonthDay[year];
        var yearValue = parseInt(yearStr);
        var monthValue = parseInt(yearMonthDay[month]);
        var dayValue = parseInt(yearMonthDay[day]);
        var numYearDigits = yearStr === null || yearStr === void 0 ? void 0 : yearStr.length;
        switch (numYearDigits) {
          case 1:
            yearValue = parseInt('200' + yearStr);
            break;
          case 2:
            yearValue = yearValue > 50 ? parseInt('19' + yearStr) : parseInt('20' + yearStr);
            break;
          case 3:
            yearValue = parseInt(yearStr + '0');
            break;
        }
        yearValue = yearValue || currentDate.getFullYear();
        monthValue = monthValue && monthValue > 0 && monthValue || currentDate.getMonth() + 1;
        dayValue = dayValue && dayValue > 0 && dayValue || currentDate.getDay();
        var d = new Date(yearValue, monthValue - 1, dayValue);
        return d;
      }
    };
  }, [dateFormat, iMaskDateFormat, minDate, maxDate, dateSeparator, datePositions]);
  return maskOptions;
};

export { useDateMask };
//# sourceMappingURL=use-date-mask.esm.js.map
